(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/hooks/use-login.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/hooks/use-login.js');
"use strict";

const useLogin = svs => {
  const {
    dialog
  } = svs.components;
  const displayErrorLoginDialog = () => {
    const branding = svs.core.detect.tenant('tb') ? dialog.branding.TUR : dialog.branding.SPORT;
    dialog.api.add(new dialog.Confirm({
      branding,
      type: dialog.type.ERROR,
      title: 'Inloggning',
      message: [{
        type: dialog.message.TEXT,
        text: 'Inloggningen misslyckades'
      }],
      actions: [{
        title: 'STÄNG'
      }]
    }));
  };
  const onLoginHandler = (e, formData, isValid) => {
    e.preventDefault();
    if (!isValid) {
      return;
    }
    const options = {
      method: 'POST',
      path: '/partner/sponsorship/sessions',
      data: {
        userName: formData.userName.value,
        password: formData.password.value
      }
    };
    svs.core.jupiter.post(options, (data, status) => {
      if (status === 'success') {
        svs.utils.url.navigate('/grasrotenpartner/oversikt');
      } else {
        displayErrorLoginDialog();
      }
    }, displayErrorLoginDialog);
  };
  return {
    onLoginHandler
  };
};
svs.grassroots_partner.useLogin = useLogin;

 })(window);